<template>
  <Breadcrumb />
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <form class="row g-3 form-menu-new" novalidate>
            <div v-if="errors.length > 0" class="alert alert-warning">
              <ul class="mb-0">
                <li v-for="error in errors" v-bind:key="error">
                  {{ error }}
                </li>
              </ul>
            </div>
            <div v-if="isSuccess" class="alert alert-success">
              {{
                $t(
                  "Messages.SuccessMessage",
                  {},
                  { locale: this.$store.state.activeLang }
                )
              }}
            </div>
            <div class="col-md-6">
              <label for="Name" class="form-label required"
                >{{
                  $t("Menus.Name", {}, { locale: this.$store.state.activeLang })
                }}
              </label>
              <input
                type="text"
                class="form-control"
                id="Name"
                v-model="menuData.name"
                @keyup="menuNameKeyup()"
                :autocomplete="this.$isAutoComplete"
                :spellcheck="this.$isTextSpellCheck"
                required
              />
            </div>
            <div class="col-md-6">
              <label for="FormulaName" class="form-label required">{{
                $t(
                  "Menus.FormulaName",
                  {},
                  { locale: this.$store.state.activeLang }
                )
              }}</label>
              <input
                type="text"
                class="form-control text-uppercase"
                id="FormulaName"
                @keyup="formulaNameKeyup()"
                v-model="menuData.formulaName"
                :autocomplete="this.$isAutoComplete"
                :spellcheck="this.$isTextSpellCheck"
                required
              />
            </div>
            <div class="col-12">
              <div class="form-check">
                <label for="IsActive" class="form-label">{{
                  $t(
                    "BaseModelFields.IsActive",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IsActive"
                  v-model="menuData.isActive"
                />
              </div>
              <div class="form-check">
                <label for="IsSideBarActive" class="form-label">{{
                  $t(
                    "Menus.IsSideBarActive",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IsSideBarActive"
                  v-model="menuData.isSideBarActive"
                />
              </div>
              <div class="form-check">
                <label for="IsDocumentActive" class="form-label">{{
                  $t(
                    "Menus.IsDocumentActive",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IsDocumentActive"
                  v-model="menuData.isDocumentActive"
                />
              </div>
              <div class="form-check">
                <label for="IsChatActive" class="form-label">{{
                  $t(
                    "Menus.IsChatActive",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IsChatActive"
                  v-model="menuData.isChatActive"
                />
              </div>
              <div class="form-check">
                <label for="IsDelegationActive" class="form-label">{{
                  $t(
                    "Menus.IsDelegationActive",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IsDelegationActive"
                  v-model="menuData.isDelegationActive"
                />
              </div>
              <div class="form-check">
                <label for="IsSystemNotificationActive" class="form-label">{{
                  $t(
                    "Menus.IsSystemNotificationActive",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IsSystemNotificationActive"
                  v-model="menuData.isSystemNotificationActive"
                />
              </div>
            </div>
            <ActionButtons
              @methodSave="onSubmit('0', 'btn-save')"
              @methodSaveAndNew="onSubmit('1', 'btn-save-and-new')"
              @clear="onClear()"
              :isNewRecord="true"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "MenuNew",
  components: {},
  data() {
    return {
      submitButtonHtml: String.format(
        '<span class="loading-block"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span> {0}</span></span>',
        this.$t(
          "Buttons.PleaseWait",
          {},
          { locale: this.$store.state.activeLang }
        )
      ),
      disabledButtonClasses: ".btn-save, .btn-save-and-new, .btn-clear",
      errors: [],
      menuData: {
        isActive: true,
      },
      isSuccess: false,
    };
  },
  methods: {
    onClear() {
      this.menuData = {
        isActive: true,
      };
      $(".form-menu-new").removeClass("was-validated");
    },
    menuNameKeyup: function () {
      if (String.isNullOrWhiteSpace(this.menuData.name)) {
        this.menuData.formulaName = "";
        return;
      }
      this.menuData.formulaName = String.replaceAlphanumeric(
        this.menuData.name,
        "_"
      ).toUpperCase();
    },
    formulaNameKeyup() {
      this.menuData.formulaName = String.replaceAlphanumeric(
        this.menuData.formulaName,
        "_"
      ).toUpperCase();
    },
    onSubmit(submitType, buttonName) {
      var form = $(".form-menu-new");
      form.addClass("was-validated");
      if (!form[0].checkValidity()) {
        return;
      }

      var button = $(String.format(".{0}", buttonName)),
        firstSpan = button.find("span:first"),
        loadingBlock = button.find(".loading-block"),
        disabledButtons = $(this.disabledButtonClasses);

      disabledButtons.prop("disabled", true);
      firstSpan.hide();
      if (loadingBlock.length === 0) {
        firstSpan.after(this.submitButtonHtml);
        loadingBlock = button.find(".loading-block");
      } else {
        loadingBlock.show();
      }

      this.errors = [];
      this.$prodGatewayAxios
        .post("/Lcdp-MenuNew", { ...this.menuData })
        .then((r) => {
          var response = r.data;
          if (response.isOk) {
            if (submitType == 0) {
              this.$router.push("/Menu/ListItem/" + response.publicId);
            } else {
              this.isSuccess = true;
              setTimeout(
                () => (this.isSuccess = false),
                this.$appSaveAndNewMessageDuration
              );
              this.onClear();
              firstSpan.show();
              loadingBlock.hide();
              disabledButtons.prop("disabled", false);
              form.removeClass("was-validated");
            }
          } else {
            firstSpan.show();
            loadingBlock.hide();
            disabledButtons.prop("disabled", false);
            this.errors.push(response.msg);
          }
        })
        .catch((r) => {
          firstSpan.show();
          loadingBlock.hide();
          disabledButtons.prop("disabled", false);
          this.errors.push(r);
        });
    },
  },
};
</script>
